const iconosEnum = {
  PagoEfectivo: 'mdi-cash',
  PagoTarjeta: 'mdi-credit-card-outline',
  Delivery: 'mdi-moped',
  RetiraSucursal: 'mdi-store'
}

export default Object.freeze(iconosEnum)
